import { render, staticRenderFns } from "./CardKey.vue?vue&type=template&id=bda3f370&scoped=true"
import script from "./CardKey.vue?vue&type=script&lang=js"
export * from "./CardKey.vue?vue&type=script&lang=js"
import style0 from "./CardKey.vue?vue&type=style&index=0&id=bda3f370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda3f370",
  null
  
)

export default component.exports